import React from 'react'
import Input from 'bisu-react-input'
import { Control } from 'react-redux-form/immutable'

const ByOR  = () => {
  return (
    <div className="form-group">
      <Input
        model=".or_from"
        label="OR Range From/To"
        placeholder="OR From"
      />
      <Control
        model=".or_to"
        className="form-control"
        placeholder="OR To"
      />
    </div>
  )
}

export default ByOR



// WEBPACK FOOTER //
// ./src/containers/Reports/Collections/by-or.js